module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Mobile.790c7777.jpg";